<template>
	<component :is="tag" v-bind="attributes">
        <template v-if="meSortable">
            <span class="fd-sortable-th" @click="doSort" v-html="content"></span>
			<sym-icon v-if="isSorted" :name="sortType === 'desc' ? 'caret-up-10' : 'caret-down-10'" class="fd-sortable-caret"></sym-icon>
		</template>
		<span v-else v-html="content"></span>
	</component>
</template>

<script setup lang="ts">
import {computed, type CSSProperties} from "vue";
import {Icon} from "anneca-symbols";
import {type CellBinding, injectCellAPI} from "./AgendaUtils";
import type {DataColumn} from "@t/fd/layout/Agenda";
import {escapeHtml} from "@t/util/SafeHtml";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = withDefaults(defineProps<{
	col: DataColumn,
	sortable: boolean,
	tag?: string
}>(), { tag: "th" });

const api = injectCellAPI();
const colName = computed<string>(() => props.col.fullName || props.col.name);
const meSortable = computed<boolean>(() => props.sortable && !!props.col.canSort);

const sortType = computed<string>(() => api.getSorting(colName.value));
const isSorted = computed<boolean>(() => sortType.value !== "no");

const content = computed<string>(() => {
	let content = "";
	let icon = false;
	if (props.col.icon) {
		content += Icon.fi(props.col.icon);
		icon = true;
	}
	let titleText = typeof props.col.thitle === "string" ? props.col.thitle : props.col.title;
	if (titleText) {
		if (icon) content += " ";
		content += escapeHtml(titleText);
	}
	return content;
});

const attributes = computed<CellBinding|null>(() => {
	const s:CSSProperties = {};
	if (props.col.align) s.textAlign = props.col.align;

	const bind:CellBinding = {};
	if (Object.keys(s).length > 0) bind.style = s;
	return bind;
});

function doSort() {
    api.setSorting(colName.value, sortType.value === "asc" ? "desc" : "asc", false);
}
</script>

<style>
.fd-sortable-th {
	cursor: pointer;
}
.fd-sortable-caret {
	margin-left: 4px;
	color: var(--active);
}
</style>
